var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.role === 'admin')?_c('AdminContainer'):_c('SaleContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }